
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({
  components: {
    // 注册组件
  },
  filters: {
    // 过滤器
  },
  directives: {
    // 指令
  }
})
export default class  extends Vue {
  // Prop
  @Prop({ type: String, default: 'default value' }) propValue!: string;

  // 数据
  message: string = 'Hello Vue';

  // 计算属性
  get computedValue(): string {
    return this.message.toUpperCase();
  }

  // 方法
  handleClick(): void {
    this.message = 'Clicked';
  }

  // Watch
  @Watch('message')
  onMessageChanged(newValue: string, oldValue: string): void {
    console.log('Message changed:', newValue);
  }

  // Emit
  @Emit('custom-event')
  emitEvent(): string {
    return this.message;
  }

  // 生命周期钩子
  beforeCreate(): void {
    // 实例初始化之后，数据观测和 event/watcher 事件配置之前被调用
  }

  created(): void {
    // 实例已经创建完成之后被调用。在这一步，实例已经完成了数据观测、
    // property 和 method 的计算、watch/event 事件回调。然而，挂载阶段还没有开始，
    // el property 目前不可用。
  }

  beforeMount(): void {
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
  }

  mounted(): void {
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.el 也在文档内。
  }

  beforeUpdate(): void {
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    // 这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
  }

  updated(): void {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    // 然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  }

  activated(): void {
    // keep-alive 组件激活时调用
  }

  deactivated(): void {
    // keep-alive 组件停用时调用
  }

  beforeDestroy(): void {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  }

  destroyed(): void {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器和子实例也会被销毁。
  }
}
